const RunningStatus = {
    idle: 0,
    running: 1,
    finished: 2,
    error: 3,
    noConnection: 4,
}

export { RunningStatus };